import { api } from '$app/api';

// eslint-disable-next-line import/prefer-default-export
export const getCampaigns = () => api.get('/campaigns?all=true').then((res) => res.data);
